import { Component, Input } from '@angular/core';
import { AllowedDeductionType } from 'src/app/core/companies.service';
import { Order } from 'src/app/core/orders.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-order-details-general-tax-deduction',
  templateUrl: './order-details-general-tax-deduction.component.html',
  styleUrls: ['./order-details-general-tax-deduction.component.scss'],
})
export class OrderDetailsGeneralTaxDeductionComponent {
  @Input() order?: Order;
  constructor(private utils_service: UtilsService) {}
  getDeductionTypeLabel(): string {
    if (this.order?.tax_deduction?.tax_deduction_type) {
      return this.utils_service.getDeductionTypeLabel(
        this.order?.tax_deduction?.tax_deduction_type as AllowedDeductionType,
      );
    } else {
      return '-';
    }
  }
}
